import connector from "./connector";

export async function save(file, fieldName, cardId, uNumber) {
  const formData = new FormData();

  formData.append("file", file);
  formData.append("name", file.name);
  formData.append("size", file.size);
  formData.append("type", file.type);
  formData.append("lastModified", file.lastModified);
  formData.append("cardId", cardId);
  formData.append("uNumber", uNumber);
  formData.append("fieldName", fieldName);

  return await connector.post("/api/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export async function get(params, progress) {
  try {
    const response = await connector.get("/api/download", {
      responseType: "blob",
      params: { ...params, timestamp: `${new Date().getTime()}` },
      onDownloadProgress: progress,
    });
    return {
      response,
      connector_state: {
        status: response.status,
        text: response.statusText,
      },
    };
  } catch (error) {
    return connector.catchReturn(error);
  }
}

export async function detach(data) {
  try {
    const response = await connector.post("/api/detach", { ...data });
    return {
      response,
      connector_state: {
        status: response.status,
        text: response.statusText,
      },
    };
  } catch (error) {
    return connector.catchReturn(error);
  }
}
